export default __webpack_public_path__ + "static/media/cvod-m.6b906010.svg";